module.exports = __webpack_public_path__ + "img/ch21_08_废墟之抱.b51f64ce.jpg";